module.exports = __webpack_public_path__ + "static/media/icon-live-ic-lock-on.d1487353.svg";